import { useMemo } from "react";

import { type Option, type OptionValue } from "@/components/types/option";

import { insertDivider, sortOptionsByChecked } from "../../SelectMultipleinline/helpers";

type SortSelectionOnTopProps<T extends Option> = {
  options: Array<T>;
  dataKey: string;
  optionLabel?: string;
  value?: OptionValue<T>[];
  optionValue?: string;
  showSelectedOnTop?: boolean;
  invalidateSortCounter?: number;
};

function useSortSelectOnTop<TValue extends Option>({
  options,
  invalidateSortCounter,
  dataKey,
  optionLabel,
  optionValue,
  value,
  showSelectedOnTop,
}: SortSelectionOnTopProps<TValue>) {
  const sortedTriggers = invalidateSortCounter
    ? [invalidateSortCounter, options]
    : [value, options];

  const sorted = useMemo(() => {
    if (!showSelectedOnTop) {
      return options;
    }

    const sorted = sortOptionsByChecked<TValue>([...options], value, {
      optionLabel,
      dataKey,
      optionValue,
    });

    if (showSelectedOnTop) {
      const sortedWithDivider = insertDivider<TValue>(sorted, value, {
        optionLabel,
        dataKey,
        optionValue,
      });
      return sortedWithDivider;
    }

    return sorted;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, sortedTriggers);

  return sorted;
}

export { useSortSelectOnTop };
